
import { ILookUp } from '@/models/main';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Autocomplete extends Vue {
  @Prop(Boolean) private readonly disabled!: boolean;
  @Prop(Boolean) private readonly searchLoad!: boolean;
  @Prop(String) private readonly label!: string;
  @Prop(String) private readonly model!: string;
  @Prop({ type: String, default: 'string' }) private readonly type!: string;
  @Prop(Array) private readonly activeItems!: string[];
  @Prop(Array) private readonly dates!: string[];
  @Prop(Array) private readonly drivers!: string[];
  @Prop(Array) private readonly customerCodes!: string[];
  @Prop(Array) private readonly serviceCodes!: string[];
  @Prop(Function) private autocomplete!: (params: ILookUp) => Promise<string[]>;

  private input: string[] = [];
  private inputVal = '';
  private itemSearch: string[] = [];
  private loading = false;

  private search(val: string) {
    this.inputVal = val;
    if (val) {
      this.itemSearch = [];
      this.input = this.activeItems;
      this.loading = true;

      const params: ILookUp = {
        dates: this.dates.join(','),
        driver_id: this.model === 'driverIDs' ? val : this.drivers.join(','),
        service_code: this.model === 'serviceCodes' ? val : this.serviceCodes.join(','),
        customer_code: this.model === 'customerCodes' ? val : this.customerCodes.join(','),
      };
      this.autocomplete(params)
        .then(data => {
          this.itemSearch = data;
        })
        .catch(e => console.log(e))
        .finally(() => {
          if (!this.loading) {
            this.itemSearch = [];
          }
          this.loading = false;
        });
    }
  }
  private change() {
    const difference = this.activeItems.filter(x => this.input.indexOf(x) === -1);
    if (difference.length > 0) {
      this.$emit('delete', this.model, difference[0]);
    }
    if (this.input) {
      this.$emit('add', this.model, this.input);
    }
  }
  private blur() {
    this.loading = false;
  }

  private focus() {
    if (!this.inputVal && this.activeItems.length === 0) {
      this.itemSearch = [];
    }
  }

  private clickToItem(item: string) {
    if (this.activeItems.indexOf(item) === -1) {
      this.activeItems.push(item);
    } else {
      this.activeItems.splice(this.activeItems.indexOf(item), 1);
    }
  }
}
